import { NgModule } from '@angular/core';
import { ArcSharedModule } from '@arc/arc-shared-frontend';
import { ArcConfigurationModule } from '@arc/arc-configuration-frontend';
import { LandingComponent } from '../settings/landing/landing.component';
import { SystemDrawerComponent } from '../settings/system-drawer/system-drawer.component';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { AureusModule, AureusWidgetsModule } from '@arc/aureus';
import { FormsModule } from '@angular/forms';
import { CardMerchantRegistrationModule } from '@arc/card-merchant-registration';

export const routesConfiguration: Routes = [
  { path: '', component: LandingComponent }
];

@NgModule({
  imports: [
    ArcSharedModule,
    CommonModule,
    RouterModule.forChild([]),
    AccordionModule,
    DropdownModule,
    AureusWidgetsModule,
    AureusModule,
    FormsModule,
    ArcConfigurationModule,
    CardMerchantRegistrationModule
  ],
  declarations: [LandingComponent, SystemDrawerComponent],
  exports: [LandingComponent, SystemDrawerComponent]
})
export class ConfigurationLazyModule {}
